import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import { DetailsCard } from "components";
import printJS from "lib/print-js";
import "modules/AppointmentDetails/components/AcsesReceiverCommunicationLog/AcsesReceiverCommunicationLog.scss";
import { AcsesCommunicationEvents } from "modules/AppointmentDetails/components/AcsesReceiverCommunicationLog/components/AcsesCommunicationEvents";
import { AppointmentInfo } from "modules/AppointmentDetails/components/CommunicationLog/components";
import { CommunicationLogReplacementCar } from "modules/AppointmentDetails/components/CommunicationLogReplacementCar";

import type { Appointment } from "models";

type AcsesReceiverCommunicationLogProps = {
  appointment: Appointment;
};

export const AcsesReceiverCommunicationLog = ({ appointment }: AcsesReceiverCommunicationLogProps) => {
  const { t } = useTranslation();
  const [showAcsesReceiverModal, setShowAcsesReceiverModal] = useState(false);

  const { acses_customer_communication } = appointment;
  if (!acses_customer_communication) return null;

  const handleToggleIsModalOpen = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    setShowAcsesReceiverModal(!showAcsesReceiverModal);
  };

  const handlePrint = () => {
    printJS({
      printable: "AcsesReceiverCommunicationLog-Content",
      type: "html",
      copyStyles: true,
      css: ["./AcsesReceiverCommunicationLog.scss"],
      scanStyles: false,
      targetStyles: ["*"]
    });
  };

  return (
    <>
      <div className="AcsesReceiverCommunicationLog" onClick={handleToggleIsModalOpen}>
        <DetailsCard title={t("v8_acses_receiver_log", "Acses receiver log")} icon="user" rightContent={null} showExpandArrow={false} button />
      </div>
      <Modal open={showAcsesReceiverModal}>
        <Modal.Header className="AcsesReceiverCommunicationLogHeader">
          <div className="header-title">
            <Icon name="list" />
            <div>{t("v8_acses_receiver_log", "Acses receiver log")}</div>
          </div>
          <Button onClick={handlePrint} className="action-btn" color="green">
            {t("v8_print", "Print")}
            <Icon className="print" />
          </Button>
        </Modal.Header>

        <Modal.Content id="AcsesReceiverCommunicationLog-Content" className="AcsesReceiverCommunicationLogContent" scrolling>
          <AppointmentInfo appointment={appointment} />

          <CommunicationLogReplacementCar appointment={appointment} />

          {acses_customer_communication.events && acses_customer_communication.events.length > 0 && (
            <AcsesCommunicationEvents events={acses_customer_communication.events} />
          )}
        </Modal.Content>

        <Modal.Actions className="AcsesReceiverCommunicationLogActions">
          <Button className="action-btn" color="grey" onClick={handleToggleIsModalOpen} floated="right">
            {t("v8_close", "Close")}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
